import { configureStore } from '@reduxjs/toolkit';

import authReducer from '@/features/auth/store/authSlice';
import { clearAuthState, loadAuthState, saveAuthState } from '@/features/auth/lib/authStorage';
import uiReducer from '@/features/ui/store/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer
  },
  preloadedState: {
    auth: loadAuthState()
  }
});

let previousAuthState = store.getState().auth;

store.subscribe(() => {
  const nextAuthState = store.getState().auth;

  if (nextAuthState === previousAuthState) {
    return;
  }

  previousAuthState = nextAuthState;

  if (!nextAuthState.isAuthenticated) {
    clearAuthState();
    return;
  }

  saveAuthState(nextAuthState);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
